import { Component, OnDestroy, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Observable } from 'rxjs';
import { IResult } from 'app/shared/models/result.model';
import { SnotifyService } from 'ng-snotify';
import { AppConfig } from 'app/app.config';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ISelect } from 'app/shared/models/select.model';
import { Router, ActivatedRoute } from '@angular/router';
import { ISlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { StorageService } from 'app/shared/services/storage.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../security/identity.service';
import { RecruitmentService } from '../recruitment/recruitment.service';
import { CustomerService } from '../quote/customer.service';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { OrganizationService } from '../organization/organization.service';
import { IDtoEmployeeFilter } from 'app/shared/models/employee/dto-employee-filter.model';
import { EmployeeService } from '../employee.service';
import { IDtoPayrollEmployee } from 'app/shared/models/employee/dto-payroll-employee.model';
import { SecurityService } from 'app/shared/services/security.service';
import { map } from 'rxjs/operators';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalAppearanceComponet } from 'app/views/modales/recruitment/appearance/modal-appearance.component';
import { forkJoin } from "rxjs";
import { IAppearance } from 'app/shared/models/recruitment/appearance.model';
@Component({
  selector: 'app-list-employees',
  styleUrls: ['./list-employees.style.scss'],
  templateUrl: 'list-employees.template.html'
})
export class ListEmployeesComponent implements OnDestroy, OnInit {
  /**Formularios */
  private formFilter: FormGroup;
  /**Notificaciones */
  private configToast: any;
  /**Variable de trasporte de datos */
  private result: IResult;
  /**Listas */
  private employees: IDtoPayrollEmployee[];
  /**Catalogos */

  private catalogTrademarks: Observable<IDtoCatalog[]>;
  private catalogCompanies: Observable<IDtoCatalog[]>;
  private catalogTrackingStatus: ISelect[];
  /** */
  @ViewChild(DatatableComponent, { static: false }) tableEmployees: DatatableComponent;
  /** */
  private statusLabelsMap = {
    'Baja': '<p><span class="label label-plain">Baja</span></p>',
    'Laborando en Red': '<p><span class="label label-success">Laborando en Red</span></p>'
  };
  /**Variables */
  public nav: any;
  private clients: any;
  private now: number;
  /**Slim-control */
  optsSlim: ISlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;
  private search: string;
  private modalRef: BsModalRef;
  private configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  public constructor(private recruitmentService: RecruitmentService
    , private formBuilder: FormBuilder
    , public snotifyService: SnotifyService
    , private configGeneral: AppConfig
    , private router: Router
    , private route: ActivatedRoute
    , private spinner: NgxSpinnerService
    , private configurationService: ConfigurationService
    , private storageService: StorageService
    , private identityService: IdentityService
    , private customerService: CustomerService
    , private organizationService: OrganizationService
    , private employeeService: EmployeeService
    , private securityService: SecurityService
    , private modalService: BsModalService) {
    this.nav = document.querySelector('nav.navbar');
    this.configToast = configGeneral.getConfigToast();
    this.optsSlim = configGeneral.getConfigSlimScroll();
    this.initializeFormFilter();
    const showRoles = this.securityService.getUserRolesStorage();
    if (showRoles !== '') {
      this.clients = showRoles.listClients;
    }
  }

  public ngOnInit(): any {
    this.scrollEvents = new EventEmitter<SlimScrollEvent>();
    this.now = Date.now();
    this.nav.className += ' white-bg';
    if (this.configurationService.isReady) {
      this.spinner.show();
      this.obetenerCatalogos();
      //this.initFilters();
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.spinner.show();
        this.obetenerCatalogos();
        //this.initFilters();
      });
    }
  }
  private initFilters(): void {
    const values = this.storageService.retrieve('recruitments.filters');
    if (values != null) {
      this.formFilter.patchValue(values);
    }
    const search = this.storageService.retrieve('recruitments.search');
    if (search != undefined) {
      this.search = search;
    }
    let getJobCandidates = false;
    Object.keys(this.formFilter.controls).forEach(field => {
      const control = this.formFilter.get(field);
      if (control.value != null) {
        getJobCandidates = true;
        return;
      }
    });
    if (getJobCandidates) {
      this.getEmployees(false);
    }
    else {
      this.getEmployees(true);
    }
  }
  private obetenerCatalogos(): void {

    this.catalogTrademarks = this.configureCatalogsTrademarks();
    this.catalogCompanies = this.organizationService.getCatalogCompanies();
    this.recruitmentService.getCatalogTrackingStatus().subscribe (res => {
      this.catalogTrackingStatus = res.filter(x => x.id == '13' || x.id == '17')
    });
    this.spinner.hide();
  }
  private configureCatalogsTrademarks(): Observable<IDtoCatalog[]> {
    const clients = new Array as IDtoCatalog[];
    const t = this.customerService.getCatalogCustomers().pipe(
      map((res: any) => {
        this.clients.forEach(element => {
          const z = res.filter(x => x.id == element.clientId)[0];
          console.log(element.clientId);
          if (z != undefined)
            clients.push(z);
        });
        return clients;
      })
    );
    return t;
  }
  private initializeFormFilter() {
    this.formFilter = this.formBuilder.group({
      companyId: [null],
      customerId: [null],
      employeeNumber: [null],
      lastName: [null],
      secondLastName: [null],
      firstName: [null],
      trackingStatusId: [null]
    });
  }
  private navigateTo(row: IDtoPayrollEmployee): void {
    const values = this.formFilter.value;
    this.storageService.store('recruitments.filters', values);
    this.storageService.store('recruitments.search', this.search);
    this.router.navigate(['/employees/update',
      { id: row.id, action: 'update', companyPayId: row.companyPayId, customerId: row.customerId }], { relativeTo: this.route });
  }
  private getEmployees(initialize: boolean): void {
    this.spinner.show();
    const emps = new Array as IDtoPayrollEmployee[];
    let values = this.formFilter.value as IDtoEmployeeFilter;
    this.employeeService.getListPayrollEmployees(values).subscribe((res) => {
      this.clients.forEach(element => {
        const z = res.filter(x => x.customerId == element.clientId);
        emps.push(...z);
      });
      this.employees = emps;
      this.spinner.hide();
    });
  }
  public ngOnDestroy(): any {
    this.nav.classList.remove('white-bg');
  }

  private addModuleLog(id: number): void {
    let dto = {} as IDtoModuleLog;
    dto.table = 'JobCandidates';
    dto.module = "requestReviews";
    dto.action = 'hiring';
    dto.registryAffectedId = id;
    this.identityService.addModuleLog(dto).subscribe(
      (x) => { });
  }
  private getCatalogs(row: IDtoPayrollEmployee): void {
    this.spinner.show();
    forkJoin([
      this.recruitmentService.getCatalogSizes(),
      this.recruitmentService.getCatalogPhysicalComplexions(),
      this.recruitmentService.getCatalogStatures(),
      this.recruitmentService.getCatalogShoeSizes(),
      this.recruitmentService.getCatalogShirtSizes(),
      this.recruitmentService.getJobCandidateAppearanceByJobCandidateId(row.id)
    ]).subscribe(([sizes, physicalComplexion, statures, shoeSizes, shirtSizes, appearance]) => {
      let genderSizes = sizes.filter(x => x.additional === row.gender);
      const catalogs = new Array() as Array<ISelect[]>;
      catalogs.push(genderSizes);
      catalogs.push(physicalComplexion);
      catalogs.push(statures);
      catalogs.push(shoeSizes);
      catalogs.push(shirtSizes);
      this.openModalAppearance(catalogs, appearance);
      this.spinner.hide();
    },
    (errMessage) => {
        this.spinner.hide();
        this.configGeneral.newToast('Error', errMessage.error.exception, 'error');
    });
  }
  private openModalAppearance(catalogs: Array<ISelect[]>, appearance: IAppearance) {
    const initialState = {
      listCatalogs: catalogs,
      title: 'Información de complexión física del candidato',
      action: 'update',
      appearance: appearance,
      module: 'employee'
    };
    this.modalRef = this.modalService.show(ModalAppearanceComponet
      , Object.assign({ initialState }
        , this.configModal));
    this.modalRef.content.onClose.subscribe((result) => {
      if (result) {
        //this.appearance = result;
      }
    });
  }
}
